import { Machine } from "./machine";
import { Alert } from "./alert";
import { AlertPreference } from "./alert-preference";

export class User {
    id: string;
    firstName: string;
    lastName: string;
    subscriptionStatus: string;
    phone: string;
    street: string;
    city: string;
    zip: string;
    state: string;
    country: string;
    numberOfMachines: number;
    email: string;
    alertsEnabled: boolean;
    accountRole: string;
    assignedMachines: Machine[] = [];
    alertPreferences: AlertPreference[] = [];
    defaultAlertPreferences: AlertPreference[] = []; // Same as above, just no machine Id set.
    account: Account;
    accountId: string;
    password: string;
    emailVerified: boolean;

    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }

    localCompare(other: User): number {
        let ret: number = 0;
        if (this.account && other.account) {
            ret = this.account.name.localeCompare(other.account.name);
        } else {
            ret = this.accountId.localeCompare(other.accountId);
        }
        if (!ret) {
            ret = this.fullName.localeCompare(other.fullName);
        }
        return ret;
    }

    fromJson(dict: any): User {
        this.id = dict.id;
        this.firstName = dict.firstName;
        this.lastName = dict.lastName;
        this.email = dict.email;
        this.accountId = dict.accountId;
        this.accountRole = dict.accountRole;
        this.emailVerified = dict.emailVerified;
        if (dict.status) {
            this.subscriptionStatus = dict.status;
        } else {
            this.subscriptionStatus = dict.active ? "Active" : "Inactive";
        }
        if (dict.assignedMachines && dict.assignedMachines.length) {
            this.numberOfMachines = dict.assignedMachines.length;
            for (let machine of dict.assignedMachines) {
                if (!machine.machine) {
                    continue;
                }
                let m = new Machine().fromJson(machine.machine);
                m.role = machine.role;
                this.assignedMachines.push(m);
            }
        } else {
            this.numberOfMachines = 0;
        }
        this.street = dict.street;
        this.account = dict.account;
        this.city = dict.city;
        this.zip = dict.zip;
        this.state = dict.state;
        this.country = dict.country;
        this.phone = dict.phone;
        this.alertsEnabled = dict.alertsEnabled;
        if (dict.alertPreferences) {
            for (let alertPreference of dict.alertPreferences) {
                let preference = new AlertPreference().baseFromJson(alertPreference);
                this.alertPreferences.push(preference);
            }
        }

        if (dict.defaultAlertPreferences) {
            for (let alertPreference of dict.defaultAlertPreferences) {
                let preference = new AlertPreference().baseFromJson(alertPreference);
                this.defaultAlertPreferences.push(preference);
            }
        }




        return this;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/user.ts